import { FC } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

import { useSecondaryTextColor } from "../../helpers/useSecondaryTextColor";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormIcon } from "@/forms-design-system/FormIcon";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { Date as DateIcon, Location as LocationIcon } from "@/icons/outlined";

interface EventRowDetailsProps {
  formattedDate: string;
  isMultiDate: boolean;
  address: string | null;
}

export const EventRowDetails: FC<EventRowDetailsProps> = ({ formattedDate, isMultiDate, address }) => {
  const { t } = useTranslate();
  const secondaryTextColor = useSecondaryTextColor();

  return (
    <Stack direction={{ xs: "column", sm: "row" }} gap={{ xs: 1, sm: 4 }} sx={{ minWidth: 0 }}>
      <Stack
        direction="row"
        gap={1}
        alignItems={{ xs: "flex-start", sm: "center" }}
        sx={{ minWidth: 0, flexShrink: { sm: 0 } }}
      >
        <FormIcon size="small" sx={(theme) => ({ color: theme.palette.forms.text.moderate })}>
          <DateIcon />
        </FormIcon>
        <Stack direction={{ xs: "column", sm: "row" }} gap={{ xs: 0.5, sm: 0.75 }} sx={{ minWidth: 0 }}>
          <FormTypography variant="caption" vibe="moderate" sx={{ whiteSpace: { sm: "nowrap" } }}>
            {formattedDate}
          </FormTypography>
          {isMultiDate ? (
            <FormTypography variant="caption" color={secondaryTextColor} sx={{ whiteSpace: "nowrap" }}>
              <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
                {"| "}
              </Box>
              {t("organization", "campaignCard.multiDate")}
            </FormTypography>
          ) : null}
        </Stack>
      </Stack>
      {address ? (
        <Stack direction="row" gap={1} alignItems="center" sx={{ minWidth: 0 }}>
          <FormIcon size="small" sx={(theme) => ({ color: theme.palette.forms.text.moderate })}>
            <LocationIcon />
          </FormIcon>
          <FormTypography variant="caption" vibe="moderate" noWrap sx={{ minWidth: 0 }}>
            {address}
          </FormTypography>
        </Stack>
      ) : null}
    </Stack>
  );
};
